import { InputType } from '../Enums/InputType';
import { CustomValidation } from './CustomValidation';
import { ControlLayout } from '../Enums/ControlLayout';
import { RangeNumber } from './RangeNumber';
import { ForceDirection } from '../Enums/ForceDirection';
import { Dictionary } from 'lodash';
import { Attribute } from './Attribute';
import { RadioButtonItem } from './RadioButtonItem';

export class RadioButtonOptions {
  /**
 * Represent Name Of Form Control
 */
  Name: string
  /**
*   Represent classes to RadioButton that allow us to select the TextBox by jquery or javascript 
*/

  ExtraClasses: string
  /**
*  Display validation message only on added repeater when add class "v-required"
*/
  ValidationClasses: string
  /**  Represent value of the label*/
  LabelValue: string
   /**  Represent Key of the label*/
   LabelKey:string
  /**  Represent value of the labelDescription show under RadioButton*/
  LabelDescription: string
  /**To set  value  to textbox */
  Value: RadioButtonItem
  /**
  * Display "*" beside the label 
  * if ForceAsterisk=true and IsRequired=True his display "*" ,
  * if if ForceAsterisk=false and IsRequired=false this remove "*",
  *if ForceAsterisk=false and IsRequired=True this display "*" , 
   */
  ShowAsterisk: boolean

   /** Ability to display or hide the label of TextBox */
   HideLabel:  boolean
   
  ViewType:ControlLayout=ControlLayout.Vertical

  /** Ability to set  RadioButton required */
  IsRequired: boolean

  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean

  /** Set List of Custom Attribute to RadioButton  */
  Items: RadioButtonItem[]
  /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
*/
CustomValidation: CustomValidation[]=[]
}
